import { Alert, Box, Button, Grid, TextField, Typography } from "@mui/material";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { HeavyCard } from "../components/heavy-card";
import { staticFetch } from "../util/api";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Loading } from "../components/loading";
import { AuthContext } from "../context/auth.provider";
import { IViewerVoterApiToken } from "../domain/email-token";
import { DisplaySchedule } from "../components/display-schedule";
import { IElectionRound } from "../domain/election";
import { MainLayout } from "../layout/main-layout";
import { CenterLoading } from "../components/center-loading";
import { IVoter } from "../domain/voter";
import { useCallbackDebounce } from "../util/debounce";



export const LoginPage = () => {
  const { organisation_slug, voting_round_slug } = useParams();
  const { setToken } = useContext(AuthContext)

  const [election, setElection] = useState<any>();
  useEffect(() => {
    staticFetch({
      url: `/election/${organisation_slug}/${voting_round_slug}`,
      method: "get",
    }).then((res) => {
      setElection(res.data)
    }
    );
  }, [organisation_slug, voting_round_slug]);

  const { hash } = useLocation();
  const [unique_id, access_code] = hash.replace("#", "").split(":");


  if (!organisation_slug || !voting_round_slug) {
    return <span>Slug required</span>
  }

  if (!election) {
    return <CenterLoading />
  }

  return <VoterAccessCodeForm
    election={election}
    organisation_slug={organisation_slug}
    voting_round_slug={voting_round_slug}
    access_code={access_code}
    unique_id={unique_id}
  />

};


interface VoterAccessCodeFormProps {
  election: IElectionRound;
  organisation_slug: string;
  voting_round_slug: string;
  access_code?: string;
  unique_id?: string;
}
const VoterAccessCodeForm = ({ election,
  organisation_slug,
  voting_round_slug,
  access_code,
  unique_id
}: VoterAccessCodeFormProps) => {
  const navigate = useNavigate();
  const { authByLoginToken } = useContext(AuthContext);

  const [form, setForm] = useState<any>({
    unique_id: unique_id || "",
    access_code: access_code || "",
  });
  const { voting_schedule } = election;
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  const handleLogin = useCallbackDebounce(() => {
    const { unique_id, access_code } = form;
    if (unique_id && access_code) {
      authByLoginToken(
        organisation_slug,
        voting_round_slug,
        unique_id,
        access_code
      ).then(
        (voter: IVoter) => {
          if (voter && voter.election_id) {
            navigate(`/voting/${voter.election_id}`);
          }
        }
      ).catch((err) => {
        setLoading(false);
        setError(err.message);
      })
    }
  }, [form], 100);

  useEffect(() => {
    if (organisation_slug && voting_round_slug && unique_id && access_code) {
      handleLogin();
    } else {
      setLoading(false);
    }
  }, []);

  if (loading) {
    return <CenterLoading />
  }

  return (
    <MainLayout style_config={election.style_config}>
      <Grid container>
        <Grid item xs={12}>
          <Typography variant="h4">{election.label}</Typography>
          <Typography >{election.status}</Typography>
          <hr />
        </Grid>
        <Grid item xs={12}>
          {voting_schedule ? <DisplaySchedule schedule={voting_schedule} /> : null}
        </Grid>
        <Grid item xs={12}>
          <Box display={"flex"} justifyContent={"center"}>

            <HeavyCard sx={{ mt: 8, maxWidth: 300, xs: { p: 3 }, md: { p: 4 } }}>
              <Typography variant="h6" mt={-1} mb={2}>Voter Login</Typography>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    label="Unique ID"
                    fullWidth
                    value={form.unique_id}
                    onChange={(e) => setForm((f: any) => ({ ...f, unique_id: e.target.value }))} />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    label="Access Code"
                    fullWidth
                    value={form.access_code}
                    onChange={(e) => setForm((f: any) => ({ ...f, access_code: e.target.value }))} />
                </Grid>
                {error ?
                  <Grid item xs={12}>
                    <Alert severity="error">{error}</Alert>
                  </Grid>
                  : null}

                <Grid item xs={12}>
                  <Button variant="contained" color={"interface" as any} onClick={handleLogin}>Login</Button>
                </Grid>

              </Grid>
            </HeavyCard>
          </Box>
        </Grid>
      </Grid>
    </MainLayout>
  )
}